module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921015649_T.e7bc0a26.jpg";